// src/data/comedians/john-mulaney.js

const base = {
  id: 'john-mulaney',
  slug: 'john-mulaney',
  name: 'John Mulaney',
  birthYear: 1982,
  image: require('@/assets/images/img_John_Mulaney.jpg'),
  famousWorks: [
    'Kid Gorgeous (2018)',
    'Baby J (2023)',
    'The Comeback Kid (2015)',
    'New in Town (2012)',
    'Big Mouth (co-creator)',
    'Documentary Now!',
    'SNL writer and multiple-time host',
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'American',
    shortBio: 'Sharp wit and impeccable storytelling',
    bio: `John Mulaney is an American stand-up comedian, actor, and writer known for his clever wordplay, pristine delivery, and masterful storytelling. His clean yet sophisticated comedy style, reminiscent of classic comedians while remaining distinctly modern, has earned him critical acclaim and a devoted fanbase.\n\nBorn in Chicago, Mulaney studied English literature before moving to New York to pursue comedy. He worked as a writer for "Saturday Night Live" from 2008 to 2013, co-creating memorable characters like Stefon with Bill Hader. His stand-up career took off with acclaimed specials that showcase his gift for crafting perfectly structured jokes and relatable observations.\n\nMulaney's comedy often draws from his Catholic upbringing, his experiences in New York, and astute observations about modern life. Beyond stand-up, he has created and starred in sitcoms, hosted "Saturday Night Live" multiple times, and co-created the successful animated show "Big Mouth."`,
    style: 'Storytelling, wordplay, observational, clean but sophisticated',
    achievements: [
      'Emmy Awards (multiple)',
      'Peabody Award',
      'Writers Guild Awards',
      'Grammy nomination',
      'Critical acclaim for stand-up specials',
      'Successful Broadway show',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Américain',
    shortBio: 'Esprit vif et narration irréprochable',
    bio: `John Mulaney est un comédien de stand-up, acteur et écrivain américain connu pour ses jeux de mots habiles, sa livraison irréprochable et son art de la narration. Son style comique élégant mais sophistiqué, évoquant les comédiens classiques tout en restant résolument moderne, lui a valu la critique et un fanbase dévoué.\n\nNé à Chicago, Mulaney a étudié la littérature anglaise avant de s'installer à New York pour poursuivre la comédie. Il a travaillé comme scénariste pour "Saturday Night Live" de 2008 à 2013, co-créant des personnages mémorables comme Stefon avec Bill Hader.\n\nLa comédie de Mulaney puise souvent dans son éducation catholique, ses expériences à New York et des observations perspicaces sur la vie moderne. Au-delà du stand-up, il a co-créé l'émission animée populaire "Big Mouth".`,
    style: 'Narration, jeux de mots, observationnel, épuré mais sophistiqué',
    achievements: [
      'Plusieurs Emmy Awards',
      'Peabody Award',
      'Writers Guild Awards',
      'Nomination aux Grammy',
      'Acclamation critique pour les specials stand-up',
      'Spectacle Broadway réussi',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Americano',
    shortBio: 'Agudo ingenio y narración impecable',
    bio: `John Mulaney es un comediante de stand-up, actor y escritor estadounidense conocido por su ingenioso juego de palabras, su entrega impecable y su magistral narración. Su estilo cómico limpio pero sofisticado, que recuerda a los comediantes clásicos mientras permanece claramente moderno, le ha valido el reconocimiento de la crítica.\n\nNacido en Chicago, Mulaney estudió literatura inglesa antes de mudarse a Nueva York para dedicarse a la comedia. Trabajó como escritor de "Saturday Night Live" de 2008 a 2013, co-creando personajes memorables como Stefon con Bill Hader.\n\nLa comedia de Mulaney a menudo se inspira en su crianza católica, sus experiencias en Nueva York y perspicaces observaciones sobre la vida moderna. Más allá del stand-up, co-creó el exitoso programa animado "Big Mouth".`,
    style: 'Narración, juegos de palabras, observacional, limpio pero sofisticado',
    achievements: [
      'Múltiples Emmy Awards',
      'Peabody Award',
      'Writers Guild Awards',
      'Nominación al Grammy',
      'Aclamación crítica por los especiales de stand-up',
      'Exitoso espectáculo de Broadway',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'أمريكي',
    shortBio: 'ذكاء حاد وفن قصصي لا مثيل له',
    bio: `جون مولاني كوميدي ستاند أب وممثل وكاتب أمريكي اشتُهر بلعبه الماهر بالكلمات وأسلوب تقديمه المصقول وفنّه القصصي الاستثنائي. أسلوبه الكوميدي الأنيق والمتطور، الذي يستحضر عذوبة الكلاسيكيين مع بقائه عصريًا تمامًا، أكسبه إشادة نقدية وقاعدة محبّين مخلصة.\n\nوُلد في شيكاغو ودرس الأدب الإنجليزي قبل الانتقال إلى نيويورك لمتابعة مسيرته الكوميدية. عمل كاتبًا في "Saturday Night Live" من 2008 إلى 2013، مشاركًا في ابتكار شخصيات لا تُنسى كستيفون مع بيل هايدر.\n\nكثيرًا ما تستقي كوميديا مولاني من تنشئته الكاثوليكية وتجاربه في نيويورك وملاحظاته الثاقبة عن الحياة الحديثة. وتعدّى مسيرته الستاند أب إلى المشاركة في ابتكار مسلسل الرسوم المتحركة الناجح "Big Mouth".`,
    style: 'رواية قصصية، لعب بالكلمات، ملاحظاتي، نظيف لكن متطور',
    achievements: [
      'عدة جوائز Emmy',
      'Peabody Award',
      'Writers Guild Awards',
      'ترشيح Grammy',
      'إشادة نقدية بالعروض الخاصة',
      'عرض Broadway ناجح',
    ],
  },
];
